import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { ExpenseItemEffects } from './store/expense-item.effects';
import { StoreModule } from '@ngrx/store';
import * as reducer from './store/expense-item.reducer';
import { SharedModule } from '../shared/shared.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(reducer.expenseItemsFeatureKey, reducer.reducer),
    EffectsModule.forFeature([ExpenseItemEffects])
  ]
})
export class ExpenseItemModule { }
